import { FETCH_REPORT_LIST, GET_SIGNED_URL, FETCH_REPORT_KEY_LIST } from 'actions/downloadAdvanceReport';

const initialState = {
  isLoading: false,
  reportList: [],
  reportKeys: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};
const reportListReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_REPORT_LIST.REQUEST:
    case GET_SIGNED_URL.REQUEST:
    case FETCH_REPORT_KEY_LIST.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_REPORT_KEY_LIST.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reportKeys: payload,
      };
    }

    case FETCH_REPORT_LIST.SUCCESS:
    case GET_SIGNED_URL.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reportList: payload?.results,
        page: payload?.page,
        limit: payload?.limit,
        totalPages: payload?.totalPages,
        total: payload?.totalResults,
      };
    }

    case FETCH_REPORT_LIST.FAIL:
    case GET_SIGNED_URL.FAIL:
    case FETCH_REPORT_KEY_LIST.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};

export default reportListReducer;
